import {ParentPay} from '~/modules/api/api.types';
import {formatDate} from '~/modules/utils';

interface EntitlementPaidLineProps {
  webPurchase: ParentPay.EntitlementDetail['webPurchase'];
}

/**
 * When the web purchase an entitlement came from started
 */
export const EntitlementPaidLine = ({webPurchase}: EntitlementPaidLineProps) =>
  webPurchase ? (
    <p className="text-sm text-gray-600">
      <span className="font-bold">Started:</span>{' '}
      {formatDate(webPurchase.date)}
    </p>
  ) : null;
